import React from 'react';
import { SectionContainer } from '../styles';
import { OccurrenceGeneralInfo } from './OccurrenceGeneralInfo';
import { OccurrenceDescriptions } from './OccurrenceDescriptions';
import ShowOccurrenceAttachments from '../ShowAttachments';

export function OccurrenceInfo({
  selectedOccurrence,
  show,
  startDate,
  setStartDate,
  setEndDate,
  endDate,
  errors,
  loadingUpdate,
  savingNewOccurrence,
  occurrenceValues,
  setOccurrenceValues,
  handleAddAttchmentsDirectly,
}) {
  return (
    <SectionContainer>
      <OccurrenceGeneralInfo
        selectedOccurrence={selectedOccurrence}
        show={show}
        startDate={startDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        endDate={endDate}
        errors={errors}
        loadingUpdate={loadingUpdate}
        savingNewOccurrence={savingNewOccurrence}
        occurrenceValues={occurrenceValues}
        setOccurrenceValues={setOccurrenceValues}
      />
      <OccurrenceDescriptions
        descriptions={selectedOccurrence?.descriptions}
        occurrenceType={selectedOccurrence?.fullOccurrenceType?.name}
      />
      {!show.endOccurrence && !show.addDescriptionToOccurrence && !show.changeResponsible ? (
        <ShowOccurrenceAttachments
          occurrenceId={selectedOccurrence?.id}
          medias={selectedOccurrence?.medias}
          handleAddAttchmentsDirectly={handleAddAttchmentsDirectly}
          isOccurrenceConcluded={selectedOccurrence?.fullUserConclusion !== null}
          occurrenceIsAnnulleed={selectedOccurrence.annulled}
        />
      ) : null}
    </SectionContainer>
  );
}
